import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {BIRTH_CONTROL_TELECONSULTATION_KEYS} from '~/constants/medical-questionnaires';
import {useNotification} from '~/hooks';
import {setNextQuestionnaire} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire9Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[BIRTH_CONTROL_TELECONSULTATION_KEYS.HAS_SMOKED]?.data,
  );

  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === BIRTH_CONTROL_TELECONSULTATION_KEYS.HAS_SMOKED);

  const onClickSubmit = async () => {
    dispatch(setNextQuestionnaire({value: BIRTH_CONTROL_TELECONSULTATION_KEYS.MEDICATION_BEING_TREATED}));
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.medium} />
        <UiText fontSize="lg" fontWeight="bold" mt={spacing.large} mb={spacing.small}>
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.descriptions?.default?.map(i => (
          <UiText key={i} fontSize="sm" mt={spacing.small} px={spacing.tiny}>
            {i}
          </UiText>
        ))}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire9Screen;
